'use client';
import Skeleton from '@/components/Loader/Skeleton';

const ProductCardSkeleton = ({ count = 8 }: { count?: number }) => {
  return (
    <div className="mx-2 grid grid-cols-2 gap-2 lg:grid-cols-3 lg:gap-4 2xl:grid-cols-4">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="group relative overflow-hidden h-[400px]">
          <Skeleton className="h-80 w-full rounded" />
          <div className="absolute bottom-0 left-0 right-0 flex flex-col gap-3 bg-white/30 p-4 backdrop-blur-md">
            <div className="flex flex-col justify-between space-y-2 lg:flex-row">
              <Skeleton className="h-4 w-2/3 rounded" />
              <Skeleton className="h-4 w-1/4 rounded" />
            </div>
            <div className="flex flex-col justify-between gap-2 lg:flex-row lg:items-center">
              <div className="flex gap-2">
                {[...Array(3)].map((_, colorIndex) => (
                  <div key={colorIndex} className="h-8 w-8 rounded-full border-2 bg-gray-300" />
                ))}
              </div>
              <div className="flex gap-2">
                {[...Array(2)].map((_, sizeIndex) => (
                  <Skeleton key={sizeIndex} className="h-8 w-8 rounded-full" />
                ))}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductCardSkeleton;
